export const environment = {
  production: false,
  apiUrl: 'https://api.proyinternos.sdi.es/api'
};
